<template>
  <div class="container" id="top-page" style="background-color: #eef2f5">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Open Service Calls</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <tableComponent
            :tableHeaders="openCallHeader"
            :tableItems="openCallsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-top: 30px">
        <v-expansion-panel-header class="Header"
          >Closed Service Calls</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search2"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate2" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate2" class="input_date" />
            </div>
          </div>
          <br />
          <tableComponent
            :tableHeaders="closedCallHeader"
            :tableItems="closedCallsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQServiceCall();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      openCallHeader: [
        { text: "Request Date", value: "FSCallhd_RequestDate" },
        { text: "Scheduled Date", value: "FSCallhd_SchedDate" },
        { text: "Call Number", value: "FSCallhd_CallNum" },
        { text: "Call Line", value: "FSCallDt_CallLine" },
        {
          text: "Issues Description",
          value: "FSCallDt_IssueTopics",
          sortable: true,
          class: "min-width2",
        },
        {
          text: "Serial Number",
          value: "FSCallDt_SerialNumber",
          sortable: true,
          class: "min-width2",
        },
        { text: "Equiptment ID", value: "FSCallDt_EquipID_c" },
        { text: "Priority", value: "FSCallhd_CallPriority" },
        { text: "Status", value: "Status" },
        { text: "Case Number", value: "FSCallhd_HDCaseNum" },
        { text: "Call Type", value: "FSCallhd_CallCode" },
        { text: "Part", value: "FSCallDt_PartNum" },
        { text: "Part Description", value: "FSCallDt_PartDescription" },
        { text: "Comment Text", value: "FSCallDt_CommentText" },
        { text: "Bill Line Price", value: "Calculated_BillLinePrice" },
      ],
      closedCallHeader: [
        { text: "Request Date", value: "FSCallhd_RequestDate" },
        { text: "Scheduled Date", value: "FSCallhd_SchedDate" },
        { text: "Call Number", value: "FSCallhd_CallNum" },
        { text: "Call Line", value: "FSCallDt_CallLine" },
        { text: "Issues Description", value: "FSCallDt_IssueTopics" },
        { text: "Serial Number", value: "FSCallDt_SerialNumber" },
        { text: "Equiptment ID", value: "FSCallDt_EquipID_c" },
        { text: "Priority", value: "FSCallhd_CallPriority" },
        { text: "Status", value: "Status" },
        { text: "Case Number", value: "FSCallhd_HDCaseNum" },
        { text: "Call Type", value: "FSCallhd_CallCode" },
        { text: "Part", value: "FSCallDt_PartNum" },
        { text: "Part Description", value: "FSCallDt_PartDescription" },
        { text: "Comment Text", value: "FSCallDt_CommentText" },
        { text: "Bill Line Price", value: "Calculated_BillLinePrice" },
      ],
      panel: [],
      openCalls: [],
      closedCalls: [],
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
    };
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getCloseCall", "getOpenCall"]),
    openCallsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.openCalls == null || filterKey === "") return this.openCalls;
      return this.openCalls.filter((i) => {
        return (
          i.FSCallhd_CallNum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.FSCallDt_EquipID_c.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSCallDt_IssueTopics.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSCallDt_SerialNumber.toString().toLowerCase().indexOf(filterKey) >
            -1
        );
      });
    },
    openCallsFilterDate() {
      if (this.openCallsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.openCallsFilter.filter((i) => {
          let day = i.FSCallhd_RequestDate.split("/")[0];
          let month = i.FSCallhd_RequestDate.split("/")[1];
          let year = i.FSCallhd_RequestDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.openCallsFilter;
      }
    },
    closedCallsFilter() {
      const filterKey = (this.search2 || "").toLowerCase();
      if (this.closedCalls == null || filterKey === "") return this.closedCalls;
      return this.closedCalls.filter((i) => {
        return (
          i.FSCallhd_CallNum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.FSCallDt_SerialNumber.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSCallDt_IssueTopics.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSCallDt_EquipID_c.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    closedCallsFilterDate() {
      if (this.closedCallsFilter.length > 0) {
        let from = new Date(this.fromdate2);
        let to = new Date(this.todate2);
        return this.closedCallsFilter.filter((i) => {
          let day = i.FSCallhd_RequestDate.split("/")[0];
          let month = i.FSCallhd_RequestDate.split("/")[1];
          let year = i.FSCallhd_RequestDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.closedCallsFilter;
      }
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getCloseCall() {
      this.loadCalls();
    },
    getOpenCall() {
      this.loadCalls();
    },
  },
  methods: {
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQServiceCall() {
      await this.$store.dispatch("Data/getOpenCallData");
      await this.$store.dispatch("Data/getCloseCallData");
      this.loadCalls();
    },
    loadCalls() {
      this.closedCalls = [];
      this.openCalls = [];
      if (this.getCloseCall && this.getCloseCall.length > 0)
        this.getCloseCall.forEach((el) => {
          this.closedCalls.push({
            FSCallhd_RequestDate: this.convertDate(el.FSCallhd_RequestDate),
            FSCallhd_SchedDate: this.convertDate(el.FSCallhd_SchedDate),
            FSCallhd_CallNum: el.FSCallhd_CallNum,
            FSCallDt_CallLine: el.FSCallDt_CallLine,
            FSCallDt_IssueTopics: el.FSCallDt_IssueTopics,
            FSCallDt_SerialNumber: el.FSCallDt_SerialNumber,
            FSCallDt_EquipID_c: el.FSCallDt_EquipID_c,
            FSCallhd_CallPriority: el.FSCallhd_CallPriority,
            Status: "CLOSED",
            FSCallhd_HDCaseNum: el.FSCallhd_HDCaseNum,
            FSCallDt_PartNum: el.FSCallDt_PartNum,
            FSCallhd_CallCode: el.FSCallhd_CallCode,
            FSCallDt_PartDescription: el.FSCallDt_PartDescription,
            FSCallDt_CommentText: el.FSCallDt_CommentText,
            Calculated_BillLinePrice: el.Calculated_BillLinePrice,
          });
        });
      if (this.getOpenCall && this.getOpenCall.length > 0)
        this.getOpenCall.forEach((el) => {
          this.openCalls.push({
            FSCallhd_RequestDate: this.convertDate(el.FSCallhd_RequestDate),
            FSCallhd_SchedDate: this.convertDate(el.FSCallhd_SchedDate),
            FSCallhd_CallNum: el.FSCallhd_CallNum,
            FSCallDt_CallLine: el.FSCallDt_CallLine,
            FSCallDt_IssueTopics: el.FSCallDt_IssueTopics,
            FSCallDt_SerialNumber: el.FSCallDt_SerialNumber,
            FSCallDt_EquipID_c: el.FSCallDt_EquipID_c,
            FSCallhd_CallPriority: el.FSCallhd_CallPriority,
            Status: "OPEN",
            FSCallhd_HDCaseNum: el.FSCallhd_HDCaseNum,
            FSCallDt_PartNum: el.FSCallDt_PartNum,
            FSCallhd_CallCode: el.FSCallhd_CallCode,
            FSCallDt_PartDescription: el.FSCallDt_PartDescription,
            FSCallDt_CommentText: el.FSCallDt_CommentText,
            Calculated_BillLinePrice: el.Calculated_BillLinePrice,
          });
        });
    },
  },
};
</script>

<style scoped>
.ml-20 {
  margin-left: 100px;
}

.input_date {
  outline: #d1dfe3;
}

.filter_date {
  display: flex;
  flex-direction: row;
}

.filter_date_item {
  display: flex;
  flex-direction: column;
}

.mb-20 {
  margin-bottom: 50px;
}

.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}

.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.input-search {
  margin-top: 5px;
  margin-bottom: 5px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}
</style>
